<!-- 因子分布情况 -->
<template>
  <div class="item factor-distribution">
    <div class="item-content">
      <!-- 因子分布 -->
      <div class="sub-item factorDistribution shadow">
         <h3 class="tactics">因子分布情况</h3>
        <!-- <div class="sub-item-title">
          <h3>因子分布</h3>
        </div> -->
        <vue-echarts
          ref="factorDistribution"
          width="auto"
          height="340px"
          :renderOnMounted="false"
          :options="{}"
        ></vue-echarts>
        <div class="date-selector" v-if="this.normalDates.length">
          <Slider
            :value="normal.selectedDateIndex"
            :max="this.normalDates.length - 1"
            :step="1"
            @on-change="val => {
            this.normal.selectedDateIndex = val;
          }"
            :tip-format="val => {
            return this.normalDates[val];
          }"
          ></Slider>
          <span class="start-date">{{ normalDates[0] }}</span>
          <span class="current-date">
            <DatePicker
              type="date"
              placeholder="当前日期"
              style="width: 200px;"
              :value="normalDates[normal.selectedDateIndex]"
              @on-change="date => onDateChange(date, 'normal')"
              :options="{
                disabledDate: date => {
                  return this.normalDates.indexOf(toDate(date)) === -1;
                }
              }"
            ></DatePicker>
          </span>
          <span class="end-date">{{ normalDates[normalDates.length - 1] }}</span>
        </div>
      </div>
      <!-- 因子行业分布 -->
      <div  class="sub-item factorIndustryDistribution shadow">
        <h3 class="tactics" style="margin-bottom: 54px;">因子行业分布</h3>
        <!-- <div class="sub-item-title">
          <h3>因子行业分布</h3>
        </div> -->
        <vue-echarts
          ref="factorIndustryDistribution"
          width="auto"
          height="470px"
          :renderOnMounted="false"
          :options="{}"
        ></vue-echarts>
        <div class="date-selector" v-if="this.industryDates.length">
          <Slider
            :value="industry.selectedDateIndex"
            :max="this.industryDates.length - 1"
            :step="1"
            @on-change="val => {
            this.industry.selectedDateIndex = val;
          }"
            :tip-format="val => {
            return this.industryDates[val];
          }"
          ></Slider>
          <span class="start-date">{{ industryDates[0] }}</span>
          <span class="current-date">
            <DatePicker
              type="date"
              placeholder="当前日期"
              style="width: 200px;"
              :value="industryDates[industry.selectedDateIndex]"
              @on-change="date => onDateChange(date, 'industry')"
              :options="{
                disabledDate: date => {
                  return this.industryDates.indexOf(toDate(date)) === -1;
                }
              }"
            ></DatePicker>
          </span>
          <span class="end-date">{{ industryDates[industryDates.length - 1] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import "echarts/lib/chart/line";
import "echarts/lib/component/dataZoom";
import vueEcharts from "./common/vueEcharts";
export default {
  components: { vueEcharts },
  props: {
    getData: {
      type: Object,
      required: true
    }
  },
  name: "factor-distribution",
  data() {
    return {
      data: {},
      normalDates: [],
      industryDates: [],
      // 正常因子分布
      normal: {
        selectedDateIndex: 0
      },
      // 行业因子分布
      industry: {
        selectedDateIndex: 0
      }
    };
  },
  watch: {
    "normal.selectedDateIndex": function() {
      this.drawDistribution();
    },
    "industry.selectedDateIndex": function() {
      this.drawIndustryDistribution();
    }
  },
   mounted () {
      this.init();
    }, 
  methods: {
    isValidDate(date) {
      return (
        dayjs.isDayjs(date) ||
        date instanceof Date ||
        (["string", "number"].includes(typeof date) &&
          new Date(date).toString() !== "Invalid Date")
      );
    },
    toDate(date, format = 'YYYY-MM-DD') {
      if (!this.isValidDate(date)) return date;
      return dayjs(date).format(format);
    },
    init() {
      this.data = this.getData;
      this.normalDates = this.data.listValuesByDate.map(item => item.dtDay);
      this.industryDates = this.data.listIndustDistByDate.map(
        item => item.dtDay
      );
      this.normal.selectedDateIndex = 0;
      this.industry.selectedDateIndex = 0;
      this.drawDistribution();
      this.drawIndustryDistribution();
    },
    // 绘制因子分布
    drawDistribution() {
      const day = this.data.listValuesByDate[this.normal.selectedDateIndex];

      const config = {
        backgroundColor: "#fff",
        color: ["#F15A5A", "#9FCFFF", "#FFD96C"],
        tooltip: {
          trigger: "axis"
        },
        grid: {
          containLabel: true
        },
        xAxis: {
          type: "category",
          scale: true,
          splitLine: {
            lineStyle: {
              color: "#eee"
            }
          },
          data: day.listValue.map(item => {
            return `[${Number(item.listRange[0]).toFixed(4)}, ${Number(
              item.listRange[1]
            ).toFixed(4)})`;
          }),
          axisLabel: {
            rotate: 20
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "#eee"
            }
          }
        },
        series: [
          {
            type: "bar",
            name: "因子分布",
            // label: {
            //   normal: {
            //     show: true,
            //     position: 'top',
            //     /* formatter: function(params) {
            //       return params.value[1];
            //     } */
            //   },
            // },
            data: day.listValue.map(item => {
              return parseInt(item.dbValue, 10);
            }),
            // barWidth: '99.3%',
            barCategoryGap: "0%"
          }
        ]
      };

      this.$refs.factorDistribution.render(config);
    },
    // 绘制因子行业分布
    drawIndustryDistribution() {
      const day = this.data.listIndustDistByDate[
        this.industry.selectedDateIndex
      ];

      const config = {
        backgroundColor: "#fff",
        color: ["#F15A5A", "#9FCFFF", "#FFD96C"],
        legend: {
          data: ["20%分位数", "中位数", "80%分位数"],
          textStyle: {
            color: "#999"
          }
        },
        tooltip: {
          trigger: "axis"
        },
        grid: {
          bottom: 100
        },
        xAxis: {
          type: "category",
          splitLine: {
            lineStyle: {
              color: "#eee"
            }
          },
          axisLabel: {
            rotate: 20
          },
          data: day.listValueUnit.map(item => item.wstrIndustry)
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "#eee"
            }
          }
        },
        series: [
          {
            type: "bar",
            name: "20%分位数",
            stack: "s",
            data: day.listValueUnit.map(item =>
              Number(item.dbValue20).toFixed(2)
            )
          },
          {
            type: "bar",
            name: "中位数",
            stack: "s",
            data: day.listValueUnit.map(item =>
              Number(item.dbValue50).toFixed(2)
            )
          },
          {
            type: "bar",
            name: "80%分位数",
            stack: "s",
            data: day.listValueUnit.map(item =>
              Number(item.dbValue80).toFixed(2)
            )
          }
        ]
      };

      this.$refs.factorIndustryDistribution.render(config);
    },
    onDateChange(date, type = "normal") {
      const index = this[`${type}Dates`].indexOf(this.toDate(date));
      if (index !== -1) {
        this[type].selectedDateIndex = index;
      }
    }
  }
};
</script>

<style lang="less">
.factor-distribution {
  .tactics {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
    height: 42px;
    line-height: 42px;
    background: rgba(240, 242, 245, 1);
    box-shadow: 0px 0px 8px 0px rgba(239, 242, 255, 1);
    text-shadow: 0px 0px 4px rgba(214, 234, 255, 1);
    padding-left: 10px;
  }
   .shadow {
     background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(214, 234, 255, 1);
    padding-bottom: 23px;
    margin-bottom: 20px;
  }
  .strategy-performance-left {
    margin-right: 10px;
  }
  .strategy-performance-left,
  .strategy-performance-right {
    flex: 1;
    background-color: #fff;
    padding: 0 16px 10px;
    p {
      display: flex;
      padding: 10px 4px;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      color: #666;
      font-size: 14px;
    }
  }
  .date-selector {
    text-align: center;
    .start-date {
      float: left;
    }
    .end-date {
      float: right;
    }
  }
}
</style>
